import Vue from "vue";
import axios from "./axios";

// global array of cancel token
// eslint-disable-next-line prefer-const
let cancelTokens = [];

// boolean to control multifiring of editUserPermission api as header value didnt change when page changed
let permissionApiFired = false;
let userIdFetched = false;

// forcelogout a user when permission is updated
async function updatePermissionsForceLogout() {
  localStorage.removeItem("userToken");
  localStorage.removeItem("email");
  localStorage.removeItem("tokenExpireAt");
  localStorage.removeItem("permissions");
  localStorage.removeItem("cityid");
  localStorage.removeItem("locale");
  localStorage.removeItem("group");
  localStorage.removeItem("userName");
  localStorage.removeItem("userInitial");
  localStorage.removeItem("locationid");
  localStorage.removeItem("locationName");
  localStorage.removeItem("pdfjs.history");
  localStorage.removeItem("locations");
  localStorage.removeItem("actionUser");
  localStorage.removeItem("projectUser");
  localStorage.removeItem("locationFilter");

  await axios.post(`/api/auth/logout/`);

  setTimeout(() => {
    window.location.reload();
  }, 1000);
}

// update the permissions_updated boolean
function editUserPermission(payload) {
  permissionApiFired = true;
  const userId = payload.id;
  Vue.delete(payload, "id");
  return axios.patch(`/api/users/${userId}/`, payload);
}

// to get user object's id to fire editUserPermission api
function getUserObj(queryParams) {
  userIdFetched = true;
  return axios.get(`/api/users/`, { params: queryParams });
}

function getTimeline(reqData) {
  return axios.get('/api/timeline/', { params: reqData });
}

function getOrderStatusGraph(reqData) {
  return axios
    .get(`/api/order-status-graph/`, { params: reqData })
    .then(handleResponse);
}

async function sendPermissionUpdated(response) {
  const params = {
    search: localStorage.getItem("email"),
  };
  // response.data.key is used to check if its not login request and locatstorage has email
  const user =
    !response.data.key && localStorage.getItem("email") && !userIdFetched
      ? await getUserObj(params)
      : "";
  const userId = user.data ? user.data.results[0].pk : "";
  userId && !permissionApiFired && user.data.results[0].permissions_updated
    ? await editUserPermission({ id: userId, permissions_updated: false })
    : "";
  !response.data.key && userId && user.data.results[0].permissions_updated
    ? await updatePermissionsForceLogout()
    : "";
  userIdFetched = false; // resetting to fire getUserObj id when logged in and group changes from backeden
}

async function handleUpdatePermission(headers, response) {
  if (headers.permissions === "update" && !response.data.key) {
    await sendPermissionUpdated(response);
  }
}

function handleResponse(response) {
  const { status, headers } = response;
  if (status !== 200 && status !== 201 && status !== 202 && status !== 204) {
    if (status === 401 || status === 403) {
      updatePermissionsForceLogout();
    }
    handleUpdatePermission(headers, response); // to handle logout when the permissions are changed
    return Promise.reject({ isSuccess: false, res: response });
  }
  handleUpdatePermission(headers, response);
  return { isSuccess: true, res: response };
}

function loginUser(payload) {
  return axios
    .post(`/api/auth/login/`, payload)
    .then((res) => {
      res.status === 200
        ? (axios.defaults.headers.common = {
            Authorization: `Token ${res.data.key}`,
          })
        : "";
      return res;
    })
    .then(handleResponse);
}

function logout() {
  return axios.post(`/api/auth/logout/`).then(handleResponse);
}

function forgotPassword(payload) {
  return axios.post(`/api/auth/password/reset/`, payload).then(handleResponse);
}

function resetPassword(payload) {
  return axios
    .post(`/api/auth/password/reset/confirm/`, payload)
    .then(handleResponse);
}

function getUserList(queryParams) {
  return axios.get(`/api/users/`, { params: queryParams }).then(handleResponse);
}

function getUser(userId) {
  return axios.get(`/api/users/${userId}/`).then(handleResponse);
}

function editUser(payload) {
  const userId = payload.id;
  Vue.delete(payload, "id");
  return axios.patch(`/api/users/${userId}/`, payload).then(handleResponse);
}

function deleteUser(userId) {
  return axios.delete(`/api/users/${userId}/`).then(handleResponse);
}

function createUser(payload) {
  return axios.post(`/api/auth/registration/`, payload).then(handleResponse);
}


function createPartnerLead(payload) {
  return axios.post(`/api/partner-lead-create/`, payload).then(handleResponse);
}

function createPartnerQuotation(payload) {
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return axios.post(`/api/partner-quotation/?for_comfort=true`, payload, config).then(handleResponse);
}


function getMeasuresList() {
  return axios.get(`/api/measure-list/?category_name=isoleren`).then(handleResponse);
}

function getPermissionsList() {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/permissionslist/`, {
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getFilteredPermissionsList(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/filtered-permissionslist/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getGroupsList(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/group/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getCityGroupsList(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/city-group/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getAllGroupsList() {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/grouplist/`, { cancelToken: cancelToken.token })
    .then(handleResponse);
}

function getGroup(payload) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/group/${payload.id}/`, {
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getCityGroup(payload) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/city-group/${payload.id}/`, {
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function createGroup(payload) {
  return axios.post(`/api/group/`, payload).then(handleResponse);
}

function createCityGroup(payload) {
  return axios.post(`/api/city-group/`, payload).then(handleResponse);
}

function updateGroup(payload) {
  return axios.patch(`/api/group/${payload.pk}/`, payload).then(handleResponse);
}

function updateCityGroup(payload) {
  return axios
    .patch(`/api/city-group/${payload.pk}/`, payload)
    .then(handleResponse);
}

function deleteGroup(payload) {
  return axios.delete(`/api/group/${payload}/`).then(handleResponse);
}

function deleteCityGroup(payload) {
  return axios.delete(`/api/city-group/${payload}/`).then(handleResponse);
}

function getCategoriesList(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/category/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getAllCategories() {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/categories/`, {
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function createCategory(payload) {
  return axios.post(`/api/category/`, payload).then(handleResponse);
}

function createContact(payload) {
  return axios.post(`/api/contact/`, payload).then(handleResponse);
}

function updateCategory(payload) {
  return axios
    .patch(`/api/category/${payload.pk}/`, payload)
    .then(handleResponse);
}

function updateContact(payload) {
  return axios
    .patch(`/api/contact/${payload.pk}/`, payload)
    .then(handleResponse);
}

function deleteCategory(payload) {
  return axios.delete(`/api/category/${payload.pk}/`).then(handleResponse);
}

function getAllCategoryList() {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/category-list/`, {
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getSubsidyList(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
      .get(`/api/subsidy/`, {
        params: queryParams,
        cancelToken: cancelToken.token,
      })
      .then(handleResponse);
}

function getAllMeasureList() {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/measure-list/`, { cancelToken: cancelToken.token })
    .then(handleResponse);
}

function getAllMeasureCategoryList(reqData) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/measure-list/${reqData.id}`, { cancelToken: cancelToken.token })
    .then(handleResponse);
}

function getAllStatusList() {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/status-list/`, {
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getAllActionList() {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/action-list/`, { cancelToken: cancelToken.token })
    .then(handleResponse);
}

function getAllQuery(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/customer-query/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function saveCustomerQueryAnswer(reqData) {
  return axios
    .patch(`/api/customer-query/${reqData.id}/`, reqData)
    .then(handleResponse);
}

function getAllYearList() {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/year-list/`, {
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getCityDashboardLeadsList(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/lead/`, { params: queryParams, cancelToken: cancelToken.token })
    .then(handleResponse);
}

// local array of lead token cancellation
const leadCancelTokensList = [];

function getLeadsList(queryParams) {
  const cancelToken = axios.CancelToken.source();
  // cancel previous request from same page
  leadCancelTokensList.forEach((token) => {
    token.cancel({ isSuccess: false, tokenCancelled: true });
  });

  // push current request in list
  leadCancelTokensList.push(cancelToken);
  cancelTokens.push(cancelToken);

  return axios
    .get(`/api/lead/`, { params: queryParams, cancelToken: cancelToken.token })
    .then(handleResponse);
}

function getLeadsListCharts(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/partner-detail-lead-graph/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getCityDashboardLead(payload) {
  return axios
    .get(`/api/city-dashboard-leads/${payload.id}/`)
    .then(handleResponse);
}

function getCalendarEvents(reqData) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/outlook/calendar`, {
      params: reqData,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getTaskCalendarEvents(reqData) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/get-task-calendar-events/`, {
      params: reqData,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function createCityDashboardLead(payload) {
  return axios.post(`/api/city-dashboard-leads/`, payload).then(handleResponse);
}

function createCalendarEvent(payload) {
  return axios.post(`/outlook/calendar`, payload).then(handleResponse);
}

function createCalendarAtHp(payload) {
  return axios.post(`api/outlook/events/`, payload).then(handleResponse);
}

function deleteCalendarEvents(payload) {
  return axios
    .delete(`/outlook/calendar`, { data: payload })
    .then(handleResponse);
}

function updateCityDashboardLead(payload) {
  return axios
    .patch(`/api/city-dashboard-leads/${payload.id}/`, payload)
    .then(handleResponse);
}

function updateCalendarEvent(payload) {
  return axios.patch(`/outlook/calendar`, payload).then(handleResponse);
}

function updateCalendarAtHp(payload) {
  return axios.patch(`api/outlook/events/`, payload).then(handleResponse);
}

function updateLead(payload) {
  return axios.patch(`/api/lead/${payload.id}/`, payload).then(handleResponse);
}
function applySubsidy(payload) {
  return axios.post(`/api/subsidy/`, payload).then(handleResponse);
}
function updateSpecialLead(payload) {
  return axios
    .patch(`/api/special-lead/${payload.id}/`, payload)
    .then(handleResponse);
}

function deleteCityDashboardLead(id) {
  return axios.delete(`/api/city-dashboard-leads/${id}/`).then(handleResponse);
}

function getMeasure(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/measures/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function createMeasure(payload) {
  return axios.post(`/api/measures/`, payload).then(handleResponse);
}

function updateMeasure(payload) {
  return axios
    .patch(`/api/measures/${payload.pk}/`, payload)
    .then(handleResponse);
}

function deleteMeasure(payload) {
  return axios.delete(`/api/measures/${payload.pk}/`).then(handleResponse);
}

function getLocalSubsidyList(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/local-subsidy/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function createLocalSubsidy(payload) {
  return axios.post(`/api/local-subsidy/`, payload).then(handleResponse);
}

function updateLocalSubsidy(payload) {
  return axios
    .patch(`/api/local-subsidy/${payload.pk}/`, payload)
    .then(handleResponse);
}

function deleteLocalSubsidy(payload) {
  return axios.delete(`/api/local-subsidy/${payload.pk}/`).then(handleResponse);
}

function excelCityDashboardLead(payload) {
  const config = { headers: { "Content-Type": "multipart/form-data" } };
  return axios
    .post(`/api/excel-city-dashboard-leads/`, payload, config)
    .then(handleResponse);
}

function getCitiesList(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/cities/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getAllCitiesList(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/cities-list/`, {params: queryParams, cancelToken: cancelToken.token })
    .then(handleResponse);
}

function getAllCitiesGroupList(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/cities-group-list/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getAllDistinctCitiesList() {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/get-cities-distinct/`, {
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function createCity(payload) {
  return axios.post(`/api/cities/`, payload).then(handleResponse);
}

function updateCity(payload) {
  return axios
    .patch(`/api/cities/${payload.pk}/`, payload)
    .then(handleResponse);
}

function getCityAdminList(queryParams, id) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/city/${id}/city_admins`, { params: queryParams })
    .then(handleResponse);
}

function addCityAdmin(payload, id) {
  return axios
    .post(`/api/city/${id}/city_admins`, payload)
    .then(handleResponse);
}
function sendPasswordGeneratinglink(payload) {
  return axios
    .post(`/api/send-password-generation-link/${payload.id}/`)
    .then(handleResponse);
}

function deleteCityAdmin(payload, id) {
  return axios
    .post(`/api/city/${id}/city_admins`, payload)
    .then(handleResponse);
}

function exportExcelFile() {
  return axios
    .get(`/api/export-excel-city-dashboard-leads`, {
      responseType: "blob",
    })
    .then(handleResponse);
}

function downloadExcelLeads(queryParams) {
  return axios
    .get(`/api/download-excel-leads`, {
      params: queryParams,
      responseType: "blob",
    })
    .then(handleResponse);
}
function exportUsers(queryParams) {
  return axios
      .post(`/api/user-export/`, {
        params: queryParams,
        responseType: "blob",
      })
      .then(handleResponse);
}

function exportLeads(queryParams) {
  return axios
    .get(
      `/api/export-excel-leads/`,{ 
        params: queryParams,
        responseType: "blob",
      }
    )
    .then(handleResponse);
}
function exportHousePassport(queryParams) {
  return axios
    .get(
      `/api/export-housepassports/`,
      { params: queryParams },
      {
        responseType: "blob",
      }
    )
    .then(handleResponse);
}

function exportReview(queryParams) {
  return axios
    .post(
      `/api/export-reviews/`,
      { params: queryParams },
      {
        responseType: "blob",
      }
    )
    .then(handleResponse);
}

function exportGroups() {
  return axios
      .get('/api/export-groups/', {
        responseType: 'blob',
      })
      .then(handleResponse);
}
function getHouseScanData(payload) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/house-passport/${payload.house_hash}/`, {
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getProjectStatusList(payload) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/project/${payload.id}/project-status/`, {
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function updateHouseScanData(hash, payload) {
  return axios
    .patch(`/api/house-passport/${hash}/`, payload)
    .then(handleResponse);
}

function updateAdvisuresScan(hash, payload) {
  return axios
    .patch(`/api/house-passport/${hash}/`, payload)
    .then(handleResponse);
}

function getStreetInfo(url) {
  delete axios.defaults.headers.common.Authorization;
  const config = {
    headers: {
      accept: "application/hal+json",
      "X-Api-Key": "l7610cc2c1b3a247e7844fbf787cfdf8fd",
    },
  };
  return axios.get(`${url}`, config).then(handleResponse);
}

function getConstructionYear(url) {
  delete axios.defaults.headers.common.Authorization;
  const config = {
    headers: {
      "X-Api-Key": "l7610cc2c1b3a247e7844fbf787cfdf8fd",
      accept: "application/hal+json",
      "Accept-Crs": "epsg:28992",
    },
  };
  return axios.get(`${url}`, config).then(handleResponse);
}

function getLivingSpace(url) {
  delete axios.defaults.headers.common.Authorization;
  const config = {
    headers: {
      "X-Api-Key": "l7610cc2c1b3a247e7844fbf787cfdf8fd",
      accept: "application/hal+json",
      "Accept-Crs": "epsg:28992",
    },
  };
  return axios.get(`${url}`, config).then(handleResponse);
}

function getLocationList(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);

  return axios
    .get(
      `/api/locations/`,
      { params: queryParams },
      { cancelToken: cancelToken.token }
    )
    .then(handleResponse);
}

function getALlLocationList(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/location-list/`, { params: queryParams, cancelToken: cancelToken.token })
    .then(handleResponse);
}

function createLocation(reqData) {
  return axios.post(`/api/locations/`, reqData).then(handleResponse);
}

function createLeadPartner(reqData) {
  return axios.post(`/api/lead-partner/`, reqData).then(handleResponse);
}

function editLocation(formData) {
  const config = { headers: { "Content-Type": "multipart/form-data" } };
  const { id } = formData;
  // eslint-disable-next-line no-param-reassign
  delete formData.id;

  return axios
    .patch(
      `/api/locations/${id}/`,
      formData.image ? formData.image : formData,
      formData.image ? config : {}
    )
    .then(handleResponse);
}

function updateLeadPartner(formData) {
  const config = { headers: { "Content-Type": "multipart/form-data" } };
  const { id } = formData;
  // eslint-disable-next-line no-param-reassign
  delete formData.id;
  if (formData.logo) {
    return axios
      .patch(
        `/api/lead-partner/${id}/`,
        formData.logo,
        formData.favicon_icon ? config : {}
      )
      .then(handleResponse);
  }
  if (formData.favicon_icon) {
    return axios
      .patch(
        `/api/lead-partner/${id}/`,
        formData.favicon_icon,
        formData.favicon_icon ? config : {}
      )
      .then(handleResponse);
  }
  return axios
    .patch(`/api/lead-partner/${id}/`, formData, {})
    .then(handleResponse);
}

function getHousePassportMeasurementList(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/measurement-list/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getContactsListHousePassport(hash) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/contact-list/${hash}/`, {
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getHouseTypes() {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/house-types/`, {
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function updateUser(uid, reqData) {
  return axios.patch(`/api/user-quote/${uid}/`, reqData).then(handleResponse);
}

function getContactsList(reqData = null) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  if (reqData) {
    return axios
      .get(`/api/contact/`, {
        params: reqData,
        cancelToken: cancelToken.token,
      })
      .then(handleResponse);
  }
  return axios
    .get(`/api/contact/`, {
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getContactsFromPassportList(reqData = null) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  if (reqData) {
    return axios
      .get(`/api/house-passport/`, {
        params: reqData,
        cancelToken: cancelToken.token,
      })
      .then(handleResponse);
  }
  return axios
    .get(`/api/house-passport/`, {
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getReviewList(reqData = null) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  if (reqData) {
    return axios
      .get(`/api/reviews/`, {
        params: reqData,
        cancelToken: cancelToken.token,
      })
      .then(handleResponse);
  }
  return axios
    .get(`/api/reviews/`, {
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function createReview(payload) {
  // const token = payload.token;
  // Vue.delete(payload, "token");
  const token = payload.get("token");
  payload.delete("token"); 
  return axios
    .post(`/api/reviews/?token=${token}`, payload)
    .then(handleResponse);
}

function createMeasurement(payload) {
  return axios.post(`/api/measurements/`, payload).then(handleResponse);
}

function updateBulkLead(payload) {
  return axios.post(`/api/lead-bulk-changes/`, payload).then(handleResponse);
}

function updateMeasurement(payload) {
  return axios
    .patch(`/api/measurements/${payload.pk}/`, payload)
    .then(handleResponse);
}

function deleteContact(payload) {
  return axios
    .delete(`/api/contact/${payload.pk}/`, { data: payload })
    .then(handleResponse);
}

function deleteMeasurement(payload) {
  return axios.delete(`/api/measurements/${payload.pk}/`).then(handleResponse);
}

function createHousePassport(payload) {
  return axios.post(`/api/house-passport/`, payload).then(handleResponse);
}

function getBrandList(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/brand/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function createBrand(payload) {
  return axios.post(`/api/brand/`, payload).then(handleResponse);
}

function updateBrand(payload) {
  return axios.patch(`/api/brand/${payload.pk}/`, payload).then(handleResponse);
}

function deleteBrand(payload) {
  return axios.delete(`/api/brand/${payload.pk}/`).then(handleResponse);
}

function getModelList(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/model/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getStatusList(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/status/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getLabelsList(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/labels/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getAllLabelsList() {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/label-list/`, {
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getAllProjects() {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/projects/`, {
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}
function getEnergyReportProjects() {
  console.log('getEnergyReportProjects API function called');
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  console.log('Making API call to /api/energy-report/projects/');
  return axios
    .get(`/api/energy-report-projects/`, {
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getAllBrandList(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/brand-list/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getAllModelList(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/model-list/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function createModel(payload) {
  return axios.post(`/api/model/`, payload).then(handleResponse);
}

function createStatus(payload) {
  return axios.post(`/api/status/`, payload).then(handleResponse);
}

function createLabel(payload) {
  return axios.post(`/api/labels/`, payload).then(handleResponse);
}

function updateModel(payload) {
  return axios.patch(`/api/model/${payload.pk}/`, payload).then(handleResponse);
}

function updateLabel(payload) {
  return axios
    .patch(`/api/labels/${payload.id}/`, payload)
    .then(handleResponse);
}

function deleteModel(payload) {
  return axios.delete(`/api/model/${payload.pk}/`).then(handleResponse);
}

function deleteLabel(payload) {
  return axios.delete(`/api/labels/${payload.id}/`).then(handleResponse);
}

function getActionList(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/action/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getLeadPartners(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/lead-partner/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}
function getAllLeadPartnersList(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/lead-partners/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function deleteAction(payload) {
  return axios.delete(`/api/action/${payload.pk}/`).then(handleResponse);
}

function createActions(payload) {
  return axios.post(`/api/action/`, payload).then(handleResponse);
}

function updateActions(payload) {
  return axios
    .patch(`/api/action/${payload.pk}/`, payload)
    .then(handleResponse);
}

function getProjectList(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/project/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function deleteProject(payload) {
  return axios.delete(`/api/project/${payload.pk}/`).then(handleResponse);
}

function createProject(payload) {
  return axios.post(`/api/project/`, payload).then(handleResponse);
}

function updateProject(payload) {
  return axios
    .patch(`/api/project/${payload.pk}/`, payload)
    .then(handleResponse);
}

function createPartner(payload) {
  return axios.post(`/api/partner/`, payload).then(handleResponse);
}

function getPartnersList(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/partner/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getPartnersDetail(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/partner/${queryParams.id}/`, {
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getAllPartners(queryparam) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/partner-list/`, {
      params: queryparam,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function checkZipcode(payload) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/check-zipcode/`, {
      params: payload,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function deletePartner(payload) {
  return axios.delete(`/api/partner/${payload.pk}/`).then(handleResponse);
}

function updatePartner(payload) {
  return axios
    .patch(`/api/partner/${payload.pk}/`, payload)
    .then(handleResponse);
}

function partnerPaymentInfo(queryparams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/partner-payment-fees/${queryparams.partnerId}/`, {
      params: queryparams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getProForma(reqData) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/proforma/${reqData.pk}/`, {
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function updateProForma(payload) {
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return axios
    .patch(`/api/proforma/${payload.pk}/`, payload.formData, config)
    .then(handleResponse);
}

function getProformaPreviewPdf(reqData) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/proforma/${reqData.pk}/pdf/`, {
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function proFormaPaymentInfo() {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/proforma-prices-list/`, {
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function createProFormaMeasureFees(payload) {
  return axios
    .post(`/api/proforma-prices-measure/`, payload)
    .then(handleResponse);
}

function uploadProformaPdf(payload) {
  return axios.post(`/api/upload-proforma/`, payload).then(handleResponse);
}

function updateProFormaMeasureFees(payload) {
  return axios
    .patch(`/api/proforma-prices-measure/${payload.id}/`, payload)
    .then(handleResponse);
}

function deleteProFormaMeasureFees(payload) {
  return axios
    .delete(`/api/proforma-prices-measure/${payload.id}/`, payload)
    .then(handleResponse);
}

function createProFormaBrandFees(payload) {
  return axios
    .post(`/api/proforma-prices-brand/`, payload)
    .then(handleResponse);
}

function updateProFormaBrandFees(payload) {
  return axios
    .patch(`/api/proforma-prices-brand/${payload.id}/`, payload)
    .then(handleResponse);
}

function deleteProFormaBrandFees(payload) {
  return axios
    .delete(`/api/proforma-prices-brand/${payload.id}/`, payload)
    .then(handleResponse);
}

function createProFormaModelFees(payload) {
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return axios
    .post(`/api/proforma-prices-model/`, payload.formData, config)
    .then(handleResponse);
}

function updateProFormaModelFees(payload) {
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return axios
    .patch(`/api/proforma-prices-model/${payload.id}/`, payload.formData, config)
    .then(handleResponse);
}

function deleteProFormaModelFees(payload) {
  return axios
    .delete(`/api/proforma-prices-model/${payload.id}/`, payload)
    .then(handleResponse);
}

function createPartnerMeasureFees(payload) {
  return axios.post(`/api/partner-measure-fees/`, payload).then(handleResponse);
}

function createPartnerBrandFees(payload) {
  return axios.post(`/api/partner-brand-fees/`, payload).then(handleResponse);
}

function createPartnerModelFees(payload) {
  return axios.post(`/api/partner-model-fees/`, payload).then(handleResponse);
}

function updatePartnerMeasureFees(payload) {
  return axios
    .patch(`/api/partner-measure-fees/${payload.id}/`, payload)
    .then(handleResponse);
}

function updatePartnerBrandFees(payload) {
  return axios
    .patch(`/api/partner-brand-fees/${payload.id}/`, payload)
    .then(handleResponse);
}

function updatePartnerModelFees(payload) {
  return axios
    .patch(`/api/partner-model-fees/${payload.id}/`, payload)
    .then(handleResponse);
}

function deletePartnerModelFees(payload) {
  return axios
    .delete(`/api/partner-model-fees/${payload.id}/`, payload)
    .then(handleResponse);
}

function deletePartnerMeasureFees(payload) {
  return axios
    .delete(`/api/partner-measure-fees/${payload.id}/`, payload)
    .then(handleResponse);
}

function deletePartnerBrandFees(payload) {
  return axios
    .delete(`/api/partner-brand-fees/${payload.id}/`, payload)
    .then(handleResponse);
}

function getAllModelBrandList(reqData) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/model-list/${reqData.id}/`, {
      params: reqData,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getAllMeasureBrand(reqData) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/brand-list/${reqData.id}/`, {
      params: reqData,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getNotesList(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/notes/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getOutlookCalendarEvents(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/outlook/events/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function createNote(payload) {
  return axios.post(`/api/notes/`, payload).then(handleResponse);
}

function updateNote(payload){
  const { id } = payload;
  return axios.patch(`/api/update-note/${id}/`, payload).then(handleResponse)
}

function createCallLog(payload) {
  return axios.post(`/api/communication-logs/`, payload).then(handleResponse);
}
function getCallLog(queryParams) {
  return axios
      .get(`/api/communication-logs/`, {
        params: queryParams,
      })
      .then(handleResponse);
}
function updateCallLog(payload){
  const { id } = payload;
  const { contact_type } = payload
  return axios.patch(`/api/communication-logs/${id}/`, payload).then(handleResponse)
}
function getOrCreateProforma(payload) {
  return axios.post(`/api/proforma/`, payload).then(handleResponse);
}

function getLeadQuotation(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/lead-quotation/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getLeadQuotationByLead(leadId) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/lead-quotation-by-lead/${leadId}/`, {
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getLeadQuotationsCount(leadId) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/lead/${leadId}/quotations-count/`, {
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getLeadHistory(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/history/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getLeadHistoryDiff(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/history-diff/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getLead(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/lead/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getLeadFromId(leadId) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/lead/${leadId}/`, {
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getDocuments(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/documents/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

// partners with most leads and mesures call

function getPartnersWithMostLeadsAndMesures(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/partners-with-most-leads-and-mesures/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

// lead fees and revenue call
function getLeadFeesAndRevenue(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`api/leads-of-location-and-revenue-of-location-graph/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

// overview cards data call
function getOverviewCardsDetails(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`api/overview-cards/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

// overview page Partner with highest Rating
function getPartnersWithMostReview(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/partner-most-review/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}
function getLocationAverageReview(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/location-average-review/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}


// city overview page

function getMeasuresWithMostLeadsAndMesures() {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/measures-with-most-leads-and-measures/`, {
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getCityOverviewCards(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/city-overview-page-cards/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getLeadsVsOrdersAndInvestment(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`api/lead-vs-order-and-invesment-graph/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function deleteDocuments(id) {
  return axios.delete(`/api/documents/${id}/`).then(handleResponse);
}

function getPartnerDocuments(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/partner-documents/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function deletePartnerDocuments(id) {
  return axios.delete(`/api/partner-documents/${id}/`).then(handleResponse);
}

function uploadPartnerDocument(payload) {
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return axios
    .post(`/api/partner-documents/`, payload.formData, config)
    .then(handleResponse);
}

function createLead(payload) {
  return axios.post(`/api/lead/`, payload).then(handleResponse);
}

function createQuotation(payload) {
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };

  return axios
    .post(`/api/lead-quotation/`, payload, config)
    .then(handleResponse);
}

function uploadDocument(payload) {
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return axios
    .post(
      `/api/documents-create/${payload.house_hash}/`,
      payload.formData,
      config
    )
    .then(handleResponse);
}

function updateQuotation(payload) {
  const { id } = payload;
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  // eslint-disable-next-line no-param-reassign
  return axios
    .patch(`/api/lead-quotation/${id}/`, payload.formData, config)
    .then(handleResponse);
}

function updateQuotationStatus(quotationId, action, reason) {
  const payload = { action };
  if (reason) {
    payload.reason = reason;
  }
  return axios
    .patch(`/api/lead-quotation/${quotationId}/update-status/`, payload)
    .then(handleResponse);
}

function getLeadFee(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/get-leadfee/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getPartners(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/get-partners/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function exportPartnerInvoice(queryParams) {
  return axios
    .get(`/api/export-partner-invoice/`, {
      params: queryParams,
      responseType: "blob",
    })
    .then(handleResponse);
}

function getPartnerInvoices(queryParams) {
  return axios
    .get(`/api/partner-invoices/`, {
      params: queryParams,
    })
    .then(handleResponse);
}

function getLeadFeeExportPreview(queryParams) {
  return axios
    .get(`/api/lead-fee/export/preview`, {
      params: queryParams,
    })
    .then(handleResponse);
}

function generateLeadFeeExport(queryParams) {
  return axios
    .post(`/api/lead-fee/export/generate`, null, {
      params: queryParams,
      responseType: "blob",
    })
    .then(handleResponse);
}

function sendPartnerInvoiceToExacct(partnerInvoiceId) {
  return axios
    .post(`/api/partner-invoices/${partnerInvoiceId}/send-exacct/`)
    .then(handleResponse);
}

function getContactsFromHouse(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/get-contacts/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function sendQuotation(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/send-quotation-email/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function changeLeadStatus(payload) {
  return axios.patch(`/api/lead/${payload.pk}/`, payload).then(handleResponse);
}

function getOrdersList(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/order/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getInvoicesList(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/invoices/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function exportInvoicesCsv(queryParams) {
  return axios
    .get(`/api/invoices/export-csv/`, {
      params: queryParams,
      responseType: "blob",
    })
    .then(handleResponse);
}

function getOrdersListCharts(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/order-list/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getOrderDetail(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/order/${queryParams.id}/`, {
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}


function createOrder(payload) {
  return axios.post(`/api/order/`, payload).then(handleResponse);
}

function createOrderInvoice(payload) {
  return axios.post(`/api/order/${payload.order_id}/create-invoice/`, payload).then(handleResponse);
}

function updateOrder(payload) {
  const { id, data } = payload;

  return axios.patch(`/api/order/${id}/`, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }).then(handleResponse);
}


function viewQuotation(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/view-quotation/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function postQuotation(payload) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
      .post(`/api/view-quotation/`, payload)
      .then(handleResponse);
}

function acceptProforma(formData) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);

  for (let [key, value] of formData.entries()) {
    console.log(`${key}: ${value}`);
  }

  return axios.patch(`/api/proforma-accept/${formData.get("leadId")}/`, formData, {
    cancelToken: cancelToken.token,
    headers: {
      // Let Axios auto-set Content-Type for FormData
    }
  }).then(handleResponse);
}

function sendMailToPartner(queryParams) {
  return axios
    .get(`/api/partner-reminder/`, { params: queryParams })
    .then(handleResponse);
}

function getConfiguration() {
  return axios.get(`/api/configurations/`).then(handleResponse);
}
function getPDFRowData(energyReportID) {
  return axios.get(`/api/prepare/pdf/${energyReportID}/`).then(handleResponse);
}
function getLocationCities(reqData) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/location/${reqData.locations_id}/cities/`, {
      params: reqData,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}
function getQuotationLocationDetails(reqData) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
      .get(`/api/view-quotation-location-details/`, {
        params: {
          quote_id: reqData.quote_id,
          id: reqData.id,
          token: reqData.token,
          lead_id: reqData.leadId,
        },
        cancelToken: cancelToken.token,
      })
      .then(handleResponse);
}
function saveReportPDF(payload) {
  return axios.post(`/api/generate/pdf/${payload.energy_report_id}/`, payload).then(handleResponse);
}
function uplaodImageToS3(payload) {
  const config = { headers: { "Content-Type": "multipart/form-data" } };
  return axios.post(`/api/upload-s3-images/`, payload, config).then(handleResponse);
}

function updateConfigurations(payload) {
  return axios
    .patch(`/api/configurations/${payload.pk}/`, payload)
    .then(handleResponse);
}

function createConfigurations(payload) {
  return axios.post(`/api/configurations/`, payload).then(handleResponse);
}

function createLocationCities(payload) {
  const id = payload.location;
  // eslint-disable-next-line no-param-reassign
  delete payload.location;
  return axios
    .post(`/api/location/${id}/cities/`, payload)
    .then(handleResponse);
}

function deleteLocationCity(payload) {
  const id = payload.location;
  // eslint-disable-next-line no-param-reassign
  delete payload.location;
  return axios
    .delete(`/api/location/${id}/cities/`, { data: payload })
    .then(handleResponse);
}

function getEmployessList(reqData) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/location/${reqData.locations_id}/users/`, {
      params: reqData,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function deleteEmployee(payload) {
  const id = payload.location_id;
  // eslint-disable-next-line no-param-reassign
  delete payload.location_id;
  return axios
    .delete(`/api/location/${id}/users/`, { data: payload })
    .then(handleResponse);
}

function getUserCities(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/user/${queryParams.id}/cities/`, {
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getUserActions(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/user/${queryParams.id}/action/`, {
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getUserLocation(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/user/${queryParams.id}/location/`, {
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getLeadStatus() {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/lead-reminder/`, {
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getProjectStatus(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/project-status/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function createProjectStatus(payload) {
  return axios.post(`/api/project-status/`, payload).then(handleResponse);
}

function updateProjectStatus(payload) {
  return axios
    .patch(`/api/project-status/${payload.id}/`, payload)
    .then(handleResponse);
}

function deleteProjectStatus(payload) {
  return axios
    .delete(`/api/project-status/${payload.id}/`)
    .then(handleResponse);
}

function getProjects() {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/projects/`, {
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getAllProjectStatus() {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/all-project-status/`, {
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function createLeadStatus(payload) {
  return axios.post(`/api/lead-reminder/`, payload).then(handleResponse);
}

function updateLeadStatus(payload) {
  return axios
    .patch(`/api/lead-reminder/${payload.pk}/`, payload)
    .then(handleResponse);
}

function createTermsAndCondition(payload) {
  return axios.post(`/api/terms-and-conditions/`, payload).then(handleResponse);
}

function getTermsAndCondition(queryParams) {
  return axios
    .get(`/api/terms-and-conditions/`, { params: queryParams })
    .then(handleResponse);
}

function getTermsAndConditionOfID(payload) {
  return axios
    .get(`/api/terms-and-conditions/${payload.id}/`, payload)
    .then(handleResponse);
}

function updateTermsAndCondition(payload) {
  return axios
    .patch(`/api/terms-and-conditions/${payload.pk}/`, payload)
    .then(handleResponse);
}

function checkTermsAndCondition() {
  return axios.get(`/api/terms/`).then(handleResponse);
}

function getActiveTermsAndCondition() {
  return axios.get(`/api/active-terms/`).then(handleResponse);
}

function acceptTermsAndCondition(payload) {
  return axios.post(`/api/term-accept-partner/`, payload).then(handleResponse);
}

function getPartnersTermsAndCondition(queryParams) {
  return axios
    .get(`/api/accepted-terms-partners/`, {
      params: queryParams,
    })
    .then(handleResponse);
}

function locationPartnersExport(payload) {
  return axios
    .post(`/api/location-partner-export/`, payload, {
      responseType: "blob",
    })
    .then(handleResponse);
}

function getSpecialPartnerPDFList() {
  return axios.get("/api/special-partner-pdf/").then(handleResponse);
}

function getSpecialPartnerMeasureList() {
  return axios.get("/api/special-partner-measures/").then(handleResponse);
}

function createSpecialPartnerPDF(payload) {
  return axios
    .post("/api/special-partner-pdf/", payload, {
      "Content-Type": "multipart/form-data",
    })
    .then(handleResponse);
}

function updateSpecialPartnerPDF(item, payload) {
  return axios
    .patch(`/api/special-partner-pdf/${item.id}/`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then(handleResponse);
}

function deleteSpecialPartnerPDF(item) {
  return axios
    .delete(`/api/special-partner-pdf/${item.id}/`)
    .then(handleResponse);
}

function getProformaMaterialPricingList(params) {
  return axios
    .get("/api/proforma-material-pricing/", { params })
    .then(handleResponse);
}

function getProformaInstallationPricingList(params) {
  return axios
    .get("/api/proforma-installation-pricing/", { params })
    .then(handleResponse);
}

function getProformaTransportationPricingList(params) {
  return axios
    .get("/api/proforma-transportation-pricing/", { params })
    .then(handleResponse);
}

function getProformaSubsidiePricingList(params) {
  return axios
    .get("/api/proforma-subsidy-pricing/", { params })
    .then(handleResponse);
}

function generateProformaData(proformaId, payload) {
  return axios
    .post(`/api/proforma-auto-generated-data/${proformaId}/`, payload)
    .then(handleResponse);
}

function updateProformaMaterialPricing(payload) {
  return axios
    .patch(`/api/proforma-material-pricing/${payload.id}/`, payload)
    .then(handleResponse);
}

function createProformaMaterialPricing(payload) {
  return axios
    .post("/api/proforma-material-pricing/", payload)
    .then(handleResponse);
}

function deleteProformaMaterialPricing(itemId) {
  return axios
    .delete(`/api/proforma-material-pricing/${itemId}/`)
    .then(handleResponse);
}

function updateProformaInstallationPricing(payload) {
  return axios
    .patch(`/api/proforma-installation-pricing/${payload.id}/`, payload)
    .then(handleResponse);
}

function createProformaInstallationPricing(payload) {
  return axios
    .post("/api/proforma-installation-pricing/", payload)
    .then(handleResponse);
}

function deleteProformaInstallationPricing(itemId) {
  return axios
    .delete(`/api/proforma-installation-pricing/${itemId}/`)
    .then(handleResponse);
}

function updateProformaTransportationPricing(payload) {
  return axios
    .patch(`/api/proforma-transportation-pricing/${payload.id}/`, payload)
    .then(handleResponse);
}

function updateProformaSubsidiePricing(payload) {
  return axios
      .patch(`/api/proforma-subsidy-pricing/${payload.id}/`, payload)
      .then(handleResponse);
}

function createProformaTransportationPricing(payload) {
  return axios
    .post("/api/proforma-transportation-pricing/", payload)
    .then(handleResponse);
}

function createProformaSubsidiePricing(payload) {
  return axios
    .post("/api/proforma-subsidy-pricing/", payload)
    .then(handleResponse);
}

function deleteProformaTransportationPricing(itemId) {
  return axios
    .delete(`/api/proforma-transportation-pricing/${itemId}/`)
    .then(handleResponse);
}

function deleteProformaSubsidiePricing(itemId) {
  return axios
    .delete(`/api/proforma-subsidy-pricing/${itemId}/`)
    .then(handleResponse);
}
function sendCustomerEmailForNewQuoteIncomming(payload) {
  return axios
    .post(`/api/customer-new-quote-email/`, payload)
    .then(handleResponse);
}
function leadContacted(payload) {
  return axios
    .put(`/api/lead_contacted/`, payload)
    .then(handleResponse);
}
function noQuoteEmailEmployee(payload) {
  return axios
    .post(`/api/no-quote-email-employee/`, payload)
    .then(handleResponse);
}
function createEnergyReport(payload) {
  return axios.post(`/api/energy-report/`, payload).then(handleResponse);
}

function updateEnergyReportDetail(payload, id) {
  return axios.patch(`/api/energy-report/${id}/`, payload).then(handleResponse);
}
function sendEnergyReportCustomer(queryParams, id) {
  return axios.patch(`/api/energy-report/${id}/`, null,{ params: queryParams }).then(handleResponse);
}
function generateReportPdf(id) {
  return axios.get(`/api/generate/pdf/${id}/`).then(handleResponse);
}
function getEnergyReportList(reqData = null) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  if (reqData) {
    return axios
        .get(`/api/energy-report/`, {
          params: reqData,
          cancelToken: cancelToken.token,
        })
        .then(handleResponse);
  }
  return axios
      .get(`/api/energy-report/`, {
        cancelToken: cancelToken.token,
      })
      .then(handleResponse);
}
function getAllAdvisors(reqData) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  
  // If is_filter=true, set maximum page size to disable pagination
  if (reqData && (reqData.is_filter === true || reqData.is_filter === 'true')) {
    reqData = {
      ...reqData,
      page_size: 999999, // Maximum page size to get all results
      page: 1, // Reset to first page
    };
  }
  
  return axios
      .get(`/api/users/`, {
        params: reqData,
        cancelToken: cancelToken.token,
      })
      .then(handleResponse);
}

function getEnergyReportDetail(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
      .get(`/api/energy-report/${queryParams.id}/`, {
        cancelToken: cancelToken.token,
      })
      .then(handleResponse);
}
function getEnergyReportQuestions(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
      .get(`/api/form/render/${queryParams.id}/`, {
        cancelToken: cancelToken.token,
      })
      .then(handleResponse);
}

function updateEnergyReport(payload) {
  return axios
      .post(`/api/form/submit/`, payload)
      .then(handleResponse);
}

function TaskOrderUpdate(payload) {
  return axios
      .put(`/api/tasks/${payload.pk}/`, payload)
      .then(handleResponse);
}

function TaskStatusUpdate(payload) {
  return axios
      .put(`/api/tasks/${payload.pk}/`, payload)
      .then(handleResponse);
}

function ArchiveTask(payload){
  return axios
      .put(`/api/tasks/${payload.pk}/`, payload)
      .then(handleResponse)

}

function getArchivedTasks(queryparams){
  return axios.get(`/api/tasks-archived/`,{
    params:queryparams,
  }).then(handleResponse)
}

function getTaskListData(queryparams,) {
  return axios.get(`/api/tasks/`,{
    params:queryparams,
  }).then(handleResponse);
}


function getTaskStatusListData() {
  return axios.get(`/api/task-status/`).then(handleResponse);
}


function getCommentList(queryParams) {
  return axios
      .get(`/api/task-comment/`, {
        params: queryParams,
      })
      .then(handleResponse);
}

function getAllUsers() {
  return axios.get(`/api/user-list/`).then(handleResponse);
}


function createTaskComment(payload) {
  return axios
      .post(`/api/task-comment/`, payload)
      .then(handleResponse);
}


function getLeadsFromHouse(queryParams) {
  return axios
      .get(`/api/task-lead-list/`, {
        params: queryParams,
      })
      .then(handleResponse);
}

function exportQuotation(payload) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .post(`/api/export-quotations-by-action/`, payload, {
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getTaskOverview() {
  return axios
      .get(`/api/numeric-data/`, )
      .then(handleResponse);
}


function getAdvisorNotification(queryParams) {
  return axios
      .get(`/api/notifications/`,{
        params: queryParams,
      } )
      .then(handleResponse);
}


function markAsReadAdvisorNotification(payload) {
  return axios
      .post(`/api/notifications/mark-read/`,payload)
      .then(handleResponse);
}


function createTask(payload) {
  return axios
      .post(`/api/tasks/`, payload)
      .then(handleResponse);
}

function updateTask(payload) {
  return axios
      .patch(`/api/tasks/${payload.pk}/`, payload)
      .then(handleResponse);
}

function uploadTaskDocument(payload) {
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return axios
      .post(`/api/task-documents/`, payload.formData, config)
      .then(handleResponse);
}

function getTaskAttachmentList(queryParams) {
  return axios
      .get(`/api/task-documents/`, {
        params: queryParams,
      })
      .then(handleResponse);
}

function getUserLogs(queryParams) {
  const locale = localStorage.getItem('locale') === 'nl' ? 'nl' : '';
  return axios
      .get(`/api/task-user-logs/?lang=${locale}`, {
        params: queryParams,
      })
      .then(handleResponse);
}


function deleteAttachment(payload) {
  return axios.delete(`/api/task-documents/${payload.pk}/`).then(handleResponse);
}

function exportEnergyScanInvoice(queryParams) {
  return axios
      .get(`/api/export-energy-scan-invoice/`, { params: queryParams, responseType: "blob", })
      .then(handleResponse);
}

function getEnergyScanInvoice(queryParams) {
  return axios
      .get(`/api/previous-energy-scan-invoice/`,  )
      .then(handleResponse);
}
function getCommentsList(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/comments/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function createComment(payload) {
  return axios.post(`/api/comments/`, payload).then(handleResponse);
}

function getLeadLocalSubsidyHistory(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/lead-local-subsidy-history/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getLeadLocalSubsidyHistoryDiff(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/lead-local-subsidy-history/diff/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getLeadLocalSubsidyDetail(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/lead-local-subsidy/${queryParams.id}/`, {
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function updateLeadLocalSubsidy(payload) {
  return axios.patch(`/api/lead-local-subsidy/${payload.id}/`, payload).then(handleResponse);
}

function createLeadLocalSubsidy(payload) {
  return axios.post(`/api/lead-local-subsidy/`, payload).then(handleResponse);
}

function downloadExcelLocalSubsidies(queryParams) {
  return axios
    .get(`/api/downoad-execl-local-subsidies/`, {
      params: queryParams,
      responseType: "blob",
    })
    .then(handleResponse);
}

function downloadLeadLocalSubsidyDocuments(payload) {
  return axios
    .post(`/api/download-local-subsidy-files/`, payload, {
      responseType: "blob",
    })
    .then(handleResponse);
}

function getLocalSubsidyCountAndAmount(queryParams){
  const cancelToken = axios.CancelToken.source();
  return axios
    .get(`api/local-subsidy-count-and-amount-graph/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getLocalSubsidyOverviewCards(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/local-subsidy-overview-page-cards/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getLocalSubsidyTypesAndMeasuresGraph(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/local-subsidy-types-and-measures/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function getLocalUserSubsidy(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/user/${queryParams.id}/local-subsidy/`, {
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function updateBulkLeadLocalSubsidy(payload) {
  return axios.post(`/api/lead-local-subsidy-bulk-chnages/`, payload).then(handleResponse);
}

function getLeadLocalSubsidyList(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/lead-local-subsidy/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

function leadLocalSubsidyExcelImport(payload) {
  const config = { headers: { "Content-Type": "multipart/form-data" } };
  return axios
      .post(`/api/lead-local-subsidy-excel-import/`, payload, config)
      .then(handleResponse);
}
function sendCustomerCommunicationMessage(payload, token) {
  const config = {
    params: {},
  };
  
  // Add token if provided (for public access)
  if (token) {
    config.params.token = token;
    // For token-based requests, remove Authorization header
    if (axios.defaults.headers.common) {
      config.headers = { ...axios.defaults.headers.common };
      delete config.headers.Authorization;
    }
  }
  // If no token, axios will use default headers with Authorization (for authenticated requests)
  
  // If payload is FormData, don't set Content-Type header (browser will set it with boundary)
  if (payload instanceof FormData) {
    if (!config.headers) {
      config.headers = {};
    }
    delete config.headers['Content-Type'];
  }
  
  return axios
    .post(`/api/customer-communication-message/`, payload, config)
    .then(handleResponse);
}

function sendBulkCustomerCommunicationMessage(payload) {
  const config = {};
  
  // If payload is FormData, don't set Content-Type header (browser will set it with boundary)
  if (payload instanceof FormData) {
    if (!config.headers) {
      config.headers = {};
    }
    delete config.headers['Content-Type'];
  }
  
  return axios
    .post(`/api/customer-communication-message/bulk-create/`, payload, config)
    .then(handleResponse);
}

function getCustomerCommunicationMessages(queryParams) {
  // Public endpoint - ensure no Authorization header is sent
  const config = {
    params: queryParams,
  };
  // Explicitly set headers without Authorization for public access
  if (axios.defaults.headers.common) {
    config.headers = { ...axios.defaults.headers.common };
    delete config.headers.Authorization;
  }
  
  return axios
    .get(`/api/customer-communication-message/`, config)
    .then(handleResponse);
}

function getCustomerCommunicationMessagesByLead(leadId, token) {
  const config = {
    params: {
      lead_id: leadId,
    },
  };
  
  // Add token if provided (for public access)
  if (token) {
    config.params.token = token;
    // For token-based requests, remove Authorization header
    if (axios.defaults.headers.common) {
      config.headers = { ...axios.defaults.headers.common };
      delete config.headers.Authorization;
    }
  } else {
    // For authenticated requests (lead detail page), keep Authorization header
    // Don't set headers explicitly - let axios use default headers with Authorization
  }
  
  return axios
    .get(`/api/customer-communication-message/`, config)
    .then(handleResponse);
}

function getHousePassportLeadsMeasures(token, houseHash) {
  // Public endpoint - ensure no Authorization header is sent
  const config = {
    params: {
      token: token,
    },
  };
  
  // Add house_hash if provided
  if (houseHash) {
    config.params.house_hash = houseHash;
  }
  
  // Explicitly set headers without Authorization for public access
  if (axios.defaults.headers.common) {
    config.headers = { ...axios.defaults.headers.common };
    delete config.headers.Authorization;
  }
  
  return axios
    .get(`/api/house-passport-leads-measures/`, config)
    .then(handleResponse);
}

function getLocalSubsidyInvoicePreview(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/local-subsidy-invoice-preview/${queryParams.id}/`, {
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
  }

function createLocalSubsidyInvoice(payload) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios.post(`/api/local-subsidy-invoice/${payload.id}/`, {
    cancelToken: cancelToken.token,
  })
  .then(handleResponse);
}

function getLocalSubsidyActionsGraph(queryParams) {
  const cancelToken = axios.CancelToken.source();
  cancelTokens.push(cancelToken);
  return axios
    .get(`/api/local-subsidy-actions-graph/`, {
      params: queryParams,
      cancelToken: cancelToken.token,
    })
    .then(handleResponse);
}

// eslint-disable-next-line import/prefer-default-export
export const userService = {
  TaskOrderUpdate,
  ArchiveTask,
  getArchivedTasks,
  TaskStatusUpdate,
  uploadTaskDocument,
  getTaskAttachmentList,
  getTaskListData,
  getTaskStatusListData,
  getUserLogs,
  deleteAttachment,
  getAllUsers,
  createTask,
  updateTask,
  getCommentList,
  createTaskComment,
  getLeadsFromHouse,
  getTaskOverview,
  getAdvisorNotification,
  markAsReadAdvisorNotification,
  createTermsAndCondition,
  updateTermsAndCondition,
  getTermsAndCondition,
  getTermsAndConditionOfID,
  checkTermsAndCondition,
  getActiveTermsAndCondition,
  acceptTermsAndCondition,
  getPartnersTermsAndCondition,
  locationPartnersExport,
  loginUser,
  logout,
  forgotPassword,
  resetPassword,
  getUserList,
  createUser,
  createPartnerLead,
  createPartnerQuotation,
  getMeasuresList,
  getUser,
  deleteUser,
  getPermissionsList,
  getFilteredPermissionsList,
  createGroup,
  createCityGroup,
  getGroupsList,
  getCityGroupsList,
  getGroup,
  getCityGroup,
  updateGroup,
  updateCityGroup,
  deleteGroup,
  deleteCityGroup,
  editUser,
  getAllGroupsList,
  getCategoriesList,
  createCategory,
  updateCategory,
  deleteCategory,
  getAllCategoryList,
  getSubsidyList,
  getAllMeasureList,
  getAllMeasureCategoryList,
  getCityDashboardLeadsList,
  getLeadsList,
  getLeadsListCharts,
  getCityDashboardLead,
  getCalendarEvents,
  getTaskCalendarEvents,
  createCalendarEvent,
  createCalendarAtHp,
  createCityDashboardLead,
  updateCityDashboardLead,
  updateLead,
  applySubsidy,
  updateSpecialLead,
  deleteCityDashboardLead,
  getAllActionList,
  getAllQuery,
  saveCustomerQueryAnswer,
  getAllStatusList,
  getMeasure,
  getAllCategories,
  createMeasure,
  updateMeasure,
  deleteMeasure,
  getLocalSubsidyList,
  createLocalSubsidy,
  updateLocalSubsidy,
  deleteLocalSubsidy,
  excelCityDashboardLead,
  getCitiesList,
  createCity,
  updateCity,
  getCityAdminList,
  sendPasswordGeneratinglink,
  addCityAdmin,
  deleteCityAdmin,
  exportExcelFile,
  downloadExcelLeads,
  exportUsers,
  exportLeads,
  exportHousePassport,
  exportReview,
  updateCalendarEvent,
  updateCalendarAtHp,
  deleteCalendarEvents,
  getAllYearList,
  getLocationList,
  getAllCitiesList,
  getAllCitiesGroupList,
  createLocation,
  createLeadPartner,
  editLocation,
  updateLeadPartner,
  getHouseScanData,
  getStreetInfo,
  getConstructionYear,
  getLivingSpace,
  getHousePassportMeasurementList,
  getContactsListHousePassport,
  getHouseTypes,
  updateUser,
  updateHouseScanData,
  getProjectStatusList,
  updateAdvisuresScan,
  updateEnergyReport,
  getContactsList,
  getContactsFromPassportList,
  getReviewList,
  createReview,
  createContact,
  updateContact,
  deleteContact,
  createMeasurement,
  updateMeasurement,
  deleteMeasurement,
  createHousePassport,
  getBrandList,
  createBrand,
  updateBrand,
  deleteBrand,
  getModelList,
  getAllBrandList,
  getAllModelList,
  deleteModel,
  deleteLabel,
  createModel,
  updateModel,
  updateLabel,
  getActionList,
  getLeadStatus,
  getProjectStatus,
  createProjectStatus,
  updateProjectStatus,
  deleteProjectStatus,
  getProjects,
  getAllProjectStatus,
  getLeadPartners,
  getAllLeadPartnersList,
  deleteAction,
  createActions,
  createLeadStatus,
  updateActions,
  updateLeadStatus,
  createPartner,
  getALlLocationList,
  getPartnersList,
  getPartnersDetail,
  deletePartner,
  updatePartner,
  partnerPaymentInfo,
  createPartnerMeasureFees,
  createPartnerBrandFees,
  createPartnerModelFees,
  updatePartnerMeasureFees,
  updatePartnerBrandFees,
  updatePartnerModelFees,
  deletePartnerMeasureFees,
  deletePartnerBrandFees,
  deletePartnerModelFees,
  getProForma,
  updateProForma,
  getProformaPreviewPdf,
  proFormaPaymentInfo,
  createProFormaMeasureFees,
  uploadProformaPdf,
  updateProFormaMeasureFees,
  deleteProFormaMeasureFees,
  createProFormaBrandFees,
  updateProFormaBrandFees,
  deleteProFormaBrandFees,
  createProFormaModelFees,
  updateProFormaModelFees,
  deleteProFormaModelFees,
  getOrderDetail,
  getEnergyReportDetail,
  getEnergyReportQuestions,
  getAllModelBrandList,
  getAllMeasureBrand,
  getNotesList,
  getOutlookCalendarEvents,
  createNote,
  updateNote,
  createCallLog,
  getCallLog,
  updateCallLog,
  getOrCreateProforma,
  getLeadQuotation,
  getLeadQuotationByLead,
  getLeadQuotationsCount,
  getLeadHistory,
  getLeadHistoryDiff,
  createQuotation,
  updateQuotation,
  updateQuotationStatus,
  uploadDocument,
  getDocuments,
  getPartnersWithMostLeadsAndMesures,
  getLeadFeesAndRevenue,
  getOverviewCardsDetails,
  getPartnersWithMostReview,
  getLocationAverageReview,
  getMeasuresWithMostLeadsAndMesures,
  getCityOverviewCards,
  getLeadsVsOrdersAndInvestment,
  deleteDocuments,
  uploadPartnerDocument,
  getPartnerDocuments,
  deletePartnerDocuments,
  getLeadFee,
  getPartners,
  exportPartnerInvoice,
  getPartnerInvoices,
  getLeadFeeExportPreview,
  generateLeadFeeExport,
  sendPartnerInvoiceToExacct,
  sendQuotation,
  changeLeadStatus,
  getLead,
  getLeadFromId,
  createLead,
  getStatusList,
  getLabelsList,
  getAllLabelsList,
  getAllProjects,
  getEnergyReportProjects,
  createStatus,
  createLabel,
  getContactsFromHouse,
  getAllPartners,
  getOrdersList,
  getInvoicesList,
  exportInvoicesCsv,
  getOrdersListCharts,
  createOrder,
  createOrderInvoice,
  updateOrder,
  viewQuotation,
  postQuotation,
  acceptProforma,
  sendMailToPartner,
  checkZipcode,
  getConfiguration,
  getPDFRowData,
  saveReportPDF,
  uplaodImageToS3,
  updateConfigurations,
  createConfigurations,
  getLocationCities,
  createLocationCities,
  deleteLocationCity,
  deleteEmployee,
  getAllDistinctCitiesList,
  getEmployessList,
  getUserCities,
  getUserActions,
  getUserLocation,
  getSpecialPartnerPDFList,
  getSpecialPartnerMeasureList,
  createSpecialPartnerPDF,
  updateSpecialPartnerPDF,
  deleteSpecialPartnerPDF,
  getProformaMaterialPricingList,
  getProformaInstallationPricingList,
  getProformaTransportationPricingList,
  getProformaSubsidiePricingList,
  generateProformaData,
  updateProformaMaterialPricing,
  createProformaMaterialPricing,
  deleteProformaMaterialPricing,
  updateProformaInstallationPricing,
  createProformaInstallationPricing,
  deleteProformaInstallationPricing,
  updateProformaTransportationPricing,
  updateProformaSubsidiePricing,
  createProformaTransportationPricing,
  createProformaSubsidiePricing,
  deleteProformaTransportationPricing,
  deleteProformaSubsidiePricing,
  createEnergyReport,
  getEnergyReportList,
  getAllAdvisors,
  axios,
  cancelTokens,
  leadContacted,
  sendCustomerEmailForNewQuoteIncomming,
  exportEnergyScanInvoice,
  getEnergyScanInvoice,
  getProjectList,
  deleteProject,
  createProject,
  updateProject,
  noQuoteEmailEmployee,
  updateBulkLead,
  exportGroups,
  exportQuotation,
  updateEnergyReportDetail,
  sendEnergyReportCustomer,
  generateReportPdf,
  getOrderStatusGraph,
  getTimeline,
  getQuotationLocationDetails,
  getLeadLocalSubsidyDetail,
  updateLeadLocalSubsidy,
  createLeadLocalSubsidy,
  downloadExcelLocalSubsidies,
  downloadLeadLocalSubsidyDocuments,
  getCommentsList,
  createComment,
  getLeadLocalSubsidyHistory,
  getLeadLocalSubsidyHistoryDiff,
  getLocalSubsidyCountAndAmount,
  getLocalSubsidyOverviewCards,
  getLocalSubsidyTypesAndMeasuresGraph,
  getLocalUserSubsidy,
  updateBulkLeadLocalSubsidy,
  getLeadLocalSubsidyList,
  leadLocalSubsidyExcelImport,
  sendCustomerCommunicationMessage,
  sendBulkCustomerCommunicationMessage,
  getCustomerCommunicationMessages,
  getCustomerCommunicationMessagesByLead,
  getHousePassportLeadsMeasures,
  getLocalSubsidyInvoicePreview,
  createLocalSubsidyInvoice,
  getLocalSubsidyActionsGraph,
};

